
/* injects from baggage-loader */

'use strict';

import _ from 'lodash';
import $ from 'jquery';

import StageBaseController from '../stage-base.controller';

import { keyBoxImg, keyPNG }  from './tetraedro.const';

export default class TetraController extends StageBaseController {
    constructor($log, $state, $timeout, $interval, Dialog, Session) {
        'ngInject';
        super($log, $state, $timeout, $interval, Dialog, Session, 2);
        this.Session = Session;
    }

    $onInit(){
        this.lodash_version = _.VERSION;
        this.startGame();

        this.keyBoxes = keyBoxImg;
        this.keyImages = keyPNG;

        this.keyImages.forEach(i => {
            i.visible = false;
        })

        this.backList = [
            {bg: this.keyBoxes[0].src},
            {bg: this.keyBoxes[1].src},
            {bg: this.keyBoxes[2].src}
        ]

        $('div.stage-container').css('background', 'url(../../images/tetra/bg.png) !important');
    }
    
    onDrop(data){
        switch(data.name){
            default:
                this.$log.log(data);  
                break;
            case 'tetra-blue-key':
                this.keyImages[3].visible = true;
                this.backList[0].bg = this.keyBoxes[3].src;
                break;
            case 'tetra-red-key':
                this.keyImages[4].visible = true;
                this.backList[1].bg = this.keyBoxes[4].src;  
                break;
            case 'tetra-yellow-key':
                this.keyImages[5].visible = true;
                this.backList[2].bg = this.keyBoxes[5].src;
                break;
        } 
        this.keyCheck(); 
    }

    keyCheck(){
        let $ctrl = this;

        if (this.keyImages[3].visible && this.keyImages[4].visible && this.keyImages[5].visible){
            this.$timeout(function(){
               $ctrl.redirectToEnd();
            }, 1500);
        }
    }

    redirectToEnd(){
        this.$state.go('ending');
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/tetraedro/tetraedro.controller.js